export function validateInput(item, result, lang = "en") {
  let errors = [];
  //validation for text input
  if (item.type === "text") {
    if (item.required && result === "") {
      if (lang === "es") {
        errors.push("Este campo es obligatorio");
      } else {
        errors.push("This field is required");
      }
    }
    //if is required and result lenght > 1
    if (item.required && item.min && result.length < item.min) {
      if (lang === "es") {
        errors.push("Mínimo " + item.min + " caracteres");
      } else {
        errors.push("Min characters " + item.min);
      }
    }
    if (
      !item.required &&
      result.length >= 1 &&
      item.min &&
      result.length < item.min
    ) {
      if (lang === "es") {
        errors.push("Mínimo " + item.min + " caracteres");
      } else {
        errors.push("Min characters " + item.min);
      }
    }
    if (item.max && result.length > item.max) {
      if (lang === "es") {
        errors.push("Máximo " + item.max + " caracteres");
      } else {
        errors.push("Max characters " + item.max);
      }
    }
    //validation for select input
  } else if (item.type === "select") {
    if (item.required && result === "") {
      if (lang === "es") {
        errors.push("Este campo es obligatorio");
      } else {
        errors.push("This field is required");
      }
    }
  } else if (item.type === "single-option") {
    if (item.required && result === "") {
      if (lang === "es") {
        errors.push("Este campo es obligatorio");
      } else {
        errors.push("This field is required");
      }
    }
  } else if (item.type === "multi-option") {
    if (item.required && result === "") {
      if (lang === "es") {
        errors.push("Este campo es obligatorio");
      } else {
        errors.push("This field is required");
      }
    }
  } else if (item.type === "text-area") {
    if (item.required && result === "") {
      if (lang === "es") {
        errors.push("Este campo es obligatorio");
      } else {
        errors.push("This field is required");
      }
    }
    if (item.required && item.min && result.length < item.min) {
      if (lang === "es") {
        errors.push("Mínimo " + item.min + " caracteres");
      } else {
        errors.push("Min characters " + item.min);
      }
    }
    if (
      !item.required &&
      result.length >= 1 &&
      item.min &&
      result.length < item.min
    ) {
      if (lang === "es") {
        errors.push("Mínimo " + item.min + " caracteres");
      } else {
        errors.push("Min characters " + item.min);
      }
    }
    if (item.max && result.length > item.max) {
      if (lang === "es") {
        errors.push("Máximo " + item.max + " caracteres");
      } else {
        errors.push("Max characters " + item.max);
      }
    }
  } else if (item.type === "date") {
    if (item.required && result === "") {
      if (lang === "es") {
        errors.push("Este campo es obligatorio");
      } else {
        errors.push("This field is required");
      }
    }
  } else if (item.type === "date-range") {
    if (item.required && result === "") {
      if (lang === "es") {
        errors.push("Este campo es obligatorio");
      } else {
        errors.push("This field is required");
      }
    }
  } else if (item.type === "time") {
    if (item.required && !result.hour && !result.minute) {
      if (lang === "es") {
        errors.push("Este campo es obligatorio");
        errors.push("Elige los minutos");
        errors.push("Elige la hora");
      } else {
        errors.push("This field is required");
        errors.push("Choose minutes");
        errors.push("Choose hour");
      }
    } else {
      //if optional, but have write something must fill both
      if (result.hour && !result.minute) {
        if (lang === "es") {
          errors.push("Elige los minutos");
        } else {
          errors.push("Choose minutes");
        }
      }
      if (result.minute && !result.hour) {
        if (lang === "es") {
          errors.push("Elige la hora");
        } else {
          errors.push("Choose hour");
        }
      }
    }
  } else if (item.type === "number") {
    if (item.required && result === "") {
      if (lang === "es") {
        errors.push("Este campo es obligatorio");
      } else {
        errors.push("This field is required");
      }
    }
    //fix min with optional value
    if (item.required && item.min && parseInt(result) < item.min) {
      if (lang === "es") {
        errors.push("Valor mínimo " + item.min);
      } else {
        errors.push("Min value " + item.min);
      }
    }

    if (
      !item.required &&
      result !== "" &&
      item.min &&
      parseInt(result) < item.min
    ) {
      if (lang === "es") {
        errors.push("Valor mínimo " + item.min);
      } else {
        errors.push("Min value " + item.min);
      }
    }
    if (item.max && parseInt(result) > item.max) {
      if (lang === "es") {
        errors.push("Valor máximo " + item.max);
      } else {
        errors.push("Max value " + item.max);
      }
    }
  }
  return errors;
}

export function validateInfo(info) {
  return {
    title: info.title || "",
    description: info.description || "",
    image: info.image || "",
    titleColor: info.titleColor || "",
    textColor: info.textColor || "",
    background: info.background || "",
    buttonColor: info.buttonColor || "",
    progressColor: info.progressColor || "",
    phone: info.phone || "",
    countryCode: info.countryCode || "",
    startMessage: info.startMessage || "",
    privacy: info.privacy || "",
    submit: info.submit || false,
    inputs: info.inputs || [],
  };
}
